import Alert from "../../util/alert";
import { INVALID_CREDENTIALS_ERROR_MSG } from "../../contstants/errors";
import { setSelectedDate as setSelectedDateAction } from "../app/actions";
import { LOG_OUT, LOGIN_COMPLETE, LOGIN_ERROR, LOGIN_START } from "./constants";
import AuthenticationService from "../../services/authentication-service";

export const login = async (credentials, dispatch) => {
	dispatch({ type: LOGIN_START });
	try {
		const authData = await AuthenticationService.authenticate(credentials);
		dispatch({
			type: LOGIN_COMPLETE,
			payload: authData
		});
		setSelectedDateAction(new Date(), dispatch);
	} catch (e) {
		Alert.error(INVALID_CREDENTIALS_ERROR_MSG);
		dispatch({ type: LOGIN_ERROR });
	}
};

export const logout = async (dispatch) => {
	await AuthenticationService.signOut();
	dispatch({ type: LOG_OUT });
};
